import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query getSubscriptionV2ByToken($filter: AutoFilledFilterFindOnesubscriptionsV2Input!, $token: String!) {
    getSubscriptionV2ByToken(filter: $filter, token: $token) {
      _id
      startDate
      endDate
      cancelDate
      frequency
      status
      amountDue
      nextBillingDate
      company {
        _id
        name
      }
      customer {
        _id
        email
        companyName
        defaultPaymentMethod
        defaultPaymentMethodObj {
          type
          name
          companyId
          provider
          customerId
          expired
          _id
          updatedAt
          createdAt
          card {
            cardNo
            cardType
            holder
            expiry
          }
        }
      }
      product {
        _id
        name
        description
        defaultPrice
        unitLabel
      }
      pricing {
        _id
        name
        tieredPricing {
          _id
          perUnit
          firstUnit
          lastUnit
          flatFee
        }
      }
      changes {
        _id
        createdAt
        date
        months
        subscription
        units
        years
        updatedAt
      }
      payments {
        _id
      }
      nextPaymentAttemptDate
    }
  }
`;
